export default __webpack_public_path__ + "static/JakubKocioł-b0c575a0c58fe587976700cacd675350.png";